import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/equipment/items/$id/_detail/rule-and-policy/')({});